<script>
export default {
  name: 'StudioOrder',

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      component: null,
      detail: {}
    }
  },

  computed: {
    idType() {
      return this.$route?.query.id_type === 'pay' ? 'pay' : 'order';
    }
  },

  watch: {
    id() {
      this.refresh();
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicStore/musicmall/getOrderInfo', {
        data: {
          id: this.id,
          idType: this.idType
        }
      });

      this.$toast.clear();

      if (code === 1) {
        this.detail = data;

        let module = { default: null };
        let pageName;

        try {
          if (data.class_type === 1) {
            pageName = 'remark/pages/Order';
          }
          else {
            throw '404';
          }

          module = await import(`@cdn_js/studio/flow/${pageName}`);

          this.component = module.default;

          setTimeout(() => {
            this.$children?.[0]?.$refresh();

            try {
              const backgroundColor = window.getComputedStyle(this.$el).getPropertyValue('background-color');
              document.querySelector('html').style.backgroundColor = backgroundColor;
              document.querySelector('body').style.backgroundColor = backgroundColor;
            }
            catch (e) {
            }
          }, 0);

          // 确保清理加载提示
          setTimeout(() => {
            this.$toast.clear();
          }, 50);
        }
        catch (e) {
          this.$router.replace('/404');
        }
      }
      else {
        this.$router.replace('/404');
      }
    }
  },

  render(createElement) {
    return createElement(this.component, {
      props: {
        id: this.id,
        detail: this.detail
      }
    }, this.$slots.default)
  }
}
</script>
